import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { TrustBadges } from './components/TrustBadges';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { PackSelector } from './components/PackSelector';
import { FeaturesSection } from './components/FeaturesSection';
import { SermonsSection } from './components/SermonsSection';
import { LookInsideSection } from './components/LookInsideSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalChoiceSection } from './components/FinalChoiceSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="nvj3jfxq0epq">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="stuczpk3sn7f" />}
      <TopBar data-id="element-2" data-mp="36hvn4muyo06" />
      <main data-id="element-3" data-mp="35yomiyqxk0x">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="35ovwnmbgyrj" />
        <StatsBand data-id="element-5" data-mp="38kw6ilmzzj5" />
        <TrustBadges data-id="element-6" data-mp="3uct0lbuzo8ws" />
        <PainSection data-id="element-7" data-mp="3udkos1m9b4d1" />
        <SolutionSection data-id="element-8" data-mp="3ubztuaw15jen" />
        <PackSelector data-id="element-9" data-mp="3uevpttobhy0g" />
        <FeaturesSection data-id="element-10" data-mp="d4o09u01u88q" />
        <SermonsSection data-id="element-11" data-mp="d4xq9hl3gfef" />
        <LookInsideSection pageImages={pageImages} data-id="element-12" data-mp="d45tw4joadn3" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-13" data-mp="85ully910b6z" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-14" data-mp="86cnbaegjhma" />
        <GuaranteeSection data-id="element-15" data-mp="3gkuy3jvs9b9l" />
        <FaqSection data-id="element-16" data-mp="3gm65ruscn35z" />
        <FinalChoiceSection data-id="element-17" data-mp="3gja6a20us6ff" />
      </main>
      <Footer data-id="element-18" data-mp="3bmtij8xkfu2v" />
      <StickyCta data-id="element-19" data-mp="3bncpjulogy24" />
    </div>;
}